import { constant } from '@config/BaseSetting';
import useLocalStorage from '@hooks/useLocalStorage';
import { Skeleton } from '@mui/material';
import { useGetDashboardUrlsMutation } from '@services/WebApiService/MonitoringApi';
import HeaderPageBlock from '@ui/Blocks/Shared/HeaderPageBlock';
import { QboAlert, QboButton, QboCard, QboTypography } from '@ui/Components';
import QboCardSingleList from '@ui/Components/QboCardSingleList';
import NoStatusSection from '@ui/Sections/SystemStatusPage/NoStatusSection';
import { openNewUrl } from '@utilities/windowUtils';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function DatadogDashboardPage() {
  const { t } = useTranslation();
  const [accessTokenSet] = useLocalStorage(constant.ACCESS_TOKEN_STORAGE);
  const [getDashboardUrls, getDashboardUrlsState] = useGetDashboardUrlsMutation();

  useEffect(() => {
    getDashboardUrls({ accessToken: accessTokenSet });
  }, []);

  const fetching = getDashboardUrlsState.isLoading || getDashboardUrlsState.isUninitialized;

  return (
    <>
      <HeaderPageBlock>{t('datadog_monitoring.title')}</HeaderPageBlock>
      <QboCard isMainWrapper>
        {fetching && (
          <div style={{ display: 'contents' }}>
            <Skeleton variant="text" width="80%" />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="70%" />
            <Skeleton variant="text" width="80%" />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="70%" />
          </div>
        )}
        {!fetching && getDashboardUrlsState.data?.data && (
          <>
            <QboAlert variant="outlined" type="info">
              <QboTypography noWrap={false}>{t('datadog_monitoring.confirmation')}</QboTypography>
            </QboAlert>
            <QboCardSingleList
              leftContent={<QboTypography fontWeight="bold">Queue Monitoring</QboTypography>}
              rightContent={
                <QboButton
                  variant="contained"
                  onClick={() => {
                    openNewUrl(getDashboardUrlsState.data?.data.QueueMonitoring);
                  }}>
                  Go to The Dashboard
                </QboButton>
              }
            />
          </>
        )}
        {!fetching && !getDashboardUrlsState.data?.data && (
          <NoStatusSection
            forbiddenErrorMessage={{
              heading: t('error'),
              caption: getDashboardUrlsState.error?.data?.message,
            }}
          />
        )}
      </QboCard>
    </>
  );
}
